import { NullableDate, NullableString } from "@/code/Types";
import { BaseClientDocument } from "./BaseDocuments";

export class OpportunityAttachmentData extends BaseClientDocument {
  opportunityId: NullableString = null;
    attachments: AttachedData[] = [];
}
export class AttachedData {
  documentName!: NullableString
  addedOn!:NullableDate
}
